import { observable, action, runInAction, makeObservable } from 'mobx';
import { notify } from 'services/NotificationService';

export class BaseStore {
  constructor() {
    makeObservable(this);
  }

  @observable isLoading = false;

  @action protected fetchData = async <T>(fetchFn: () => Promise<T>, onSuccess?: (res: T) => void) => {
    try {
      this.isLoading = true;
      const data = await fetchFn();
      if (onSuccess) {
        runInAction(() => onSuccess(data));
      }
      return data;
    } catch (ex: unknown) {
      if (ex instanceof Error) {
        notify('Error', ex.message, 'error');
      }
    } finally {
      runInAction(() => (this.isLoading = false));
    }
  };
}
